import { Icon } from '@iconify/react';
import { CircularProgress, IconButton, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { getReporteIntervalo } from '../../_apis_/dagpacket-oneRequest';
import { formatDateToRequest } from '../../utils/formatTime';
import { onDownload } from '../../utils/reportes/download';
import { actionSectionIdentifier, sectionIdentifier } from '../../constants/ticketsErrors';
import useAuthUsers from '../../hooks/useAuthUsers';
import useReportError from '../../hooks/errorsHooks/useReportError';

const PedirReporteBackendButton = ({ intervaloReporte, status, userIds, desdeSection }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const { currentUser } = useAuthUsers();
  const { reportError } = useReportError();

  let endPoint;
  console.log({ desdeSection });
  if (desdeSection === 'multimarca') {
    endPoint = '/reports/multimarca';
  } else {
    endPoint = '/reports/utilidades';
  }

  // eslint-disable-next-line consistent-return
  const onGenerateReport = async () => {
    if (status[0] === 'LABEL_CREATED') {
      status = 'CREATED';
    }
    if (intervaloReporte.date_from === '' || intervaloReporte.date_to === '') {
      return alert('Por favor, selecciona un rango de fechas');
    }

    const formattedDateFrom = formatDateToRequest(intervaloReporte.date_from);
    const formattedDateTo = formatDateToRequest(intervaloReporte.date_to);

    if (formattedDateFrom === '' || formattedDateTo === '') {
      return alert('Debe seleccionar un rango de fechas');
    }
    const endDate = new Date(formattedDateTo);
    endDate.setDate(endDate.getDate());
    const intervaloReporteMasUnDia = {
      date_from: formattedDateFrom,
      date_to: endDate.toISOString().substring(0, 10)
    };
    setIsLoading(true);
    try {
      let data;

      if (Array.isArray(status) && status.length > 1) {
        setIsLoading(false);
        return alert('Debe escoger un solo status');
      }

      if (Array.isArray(status) && status.length === 0) {
        status = undefined;
      }

      if (status && Array.isArray(status) && status.length === 1) {
        [status] = status;
      }

      if (status === 'PENDIENTE-CANCELACION') {
        data = await getReporteIntervalo(
          {
            ...intervaloReporteMasUnDia,
            state: 'PENDIENTE-CANCELACION'
          },
          endPoint
        );
      } else {
        data = await getReporteIntervalo(
          {
            ...intervaloReporteMasUnDia,
            ...(status && { status }),
            ...(userIds && { userIds })
          },
          endPoint
        );
      }
      setIsLoading(false);
      setHasError(false);
      onDownload(data.link);
    } catch (error) {
      const errorData = {
        error: JSON.stringify(error),
        errorAction: actionSectionIdentifier.pedirReporteABackend,
        section: sectionIdentifier.envioListToolbar,
        created_at: new Date(),
        updated_at: new Date(),
        description: 'Error al descargar reporte de envios',
        versionApp: localStorage.getItem('versionApp'),
        user_id: currentUser.id
      };
      console.log(errorData);

      await reportError(errorData);

      console.log({ error });
      if (error.response.data.error.response.error === 'Bad Request') {
        setHasError(true);
        setIsLoading(false);
      }
      console.error({ error: error.response.data.error.response.error });
      setIsLoading(false);
    }
    setIsLoading(false);
    console.log('downloaded');
  };

  const clearReport = () => {
    setIsDownloaded(false);
  };
  return (
    <>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <>
          <Tooltip title="Generar reporte">
            <IconButton onClick={onGenerateReport}>
              <Icon icon="vscode-icons:file-type-excel" />
            </IconButton>
          </Tooltip>
          {hasError && (
            <Typography component="span" sx={{ color: 'red', fontSize: '12px' }}>
              Nada que mostrar por el momento
            </Typography>
          )}
        </>
      )}
    </>
  );
};

export default PedirReporteBackendButton;
